import EditReportContainer from "../containers/EditReportContainer";

const EditReportPage = () => {
  return (
    <EditReportContainer />
  );
};

export default EditReportPage;
